import {FC} from "react";
import {UserIncidentTabContent} from "./content";
import {useOutletContext} from "react-router-dom";
import {UserPageOutletContext} from "../index";

export const UserIncidentTab: FC<any> = () => {
    const [user] = useOutletContext<UserPageOutletContext>();
    return <UserIncidentTabContent user={user}/>;
};
